import { FC, memo } from 'react'
import { Modal } from 'components/layouts/modal/modal'
import {
  TaskEntryForm,
  TaskEntryFormMode,
} from 'features/task/components/taskEntryDialog/components/taskEntryForm/taskEntryForm'

type TaskDialogProps = {
  entryFormMode: TaskEntryFormMode
  title: string
  taskId?: string
  projectId?: string
  parentTaskId?: string
  onSubmit: (taskId: string) => void
  isOpen: boolean
  onClose: () => void
  onDeleted?: (taskId: string) => void
  defaultDueDate?: Date
  defaultAssignToUserId?: string
}

export const TaskEntryDialog: FC<TaskDialogProps> = memo((props) => {
  return (
    <Modal
      id="task-entry-dialog"
      title={props.title}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <TaskEntryForm
        entryFormMode={props.entryFormMode}
        taskId={props.taskId}
        onCancel={props.onClose}
        onSubmit={props.onSubmit}
        onDeleted={props.onDeleted}
        projectId={props.projectId}
        parentTaskId={props.parentTaskId}
        defaultDueDate={props.defaultDueDate}
        defaultAssignToUserId={props.defaultAssignToUserId}
      />
    </Modal>
  )
})
